export const DEFECT_SEVERITY_OPTIONS = ['', 'Low', 'High', 'Critical', 'Medium'];

export const DEFECT_SEVERITY_STYLES = {
    Critical: { color: '#dc3545', fontWeight: 700 },
    High: { color: '#fd7e14', fontWeight: 700 },
    Low: { color: '#212529', fontWeight: 500 },
    Medium: { color: '#856404', fontWeight: 600 },
};

/** Parse stored defectCategory (JSON array or legacy text) into a list of strings. */
export function parseDefectCategoryList(raw) {
    if (raw == null || raw === '') return [];
    if (Array.isArray(raw)) {
        return raw.map((item) => String(item).trim()).filter(Boolean);
    }
    const text = String(raw).trim();
    if (!text) return [];
    try {
        const parsed = JSON.parse(text);
        if (Array.isArray(parsed)) {
            return parsed.map((item) => String(item).trim()).filter(Boolean);
        }
    } catch (e) {
        // legacy plain text
    }
    if (text.includes('\n')) {
        return text.split('\n').map((line) => line.replace(/^\d+\.\s*/, '').trim()).filter(Boolean);
    }
    if (text.includes(',')) {
        return text.split(',').map((part) => part.replace(/^\d+\.\s*/, '').trim()).filter(Boolean);
    }
    return [text];
}

export function formatDefectCategoryDisplay(raw) {
    const items = parseDefectCategoryList(raw);
    if (!items.length) return '';
    return items.map((item, index) => `${index + 1}. ${item}`).join(', ');
}

export function serializeDefectCategoryList(list) {
    const items = (list || []).map((item) => String(item).trim()).filter(Boolean);
    return JSON.stringify(items);
}

export function normalizeDefectRow(data) {
    const defectItems = parseDefectCategoryList(data.defectCategory || data.name);
    return {
        id: data.id,
        processCategory: data.processCategory || data.code || data.name || '',
        defectCategory: formatDefectCategoryDisplay(defectItems),
        defectCategoryList: defectItems,
        severity: data.severity || '',
        physicalIndication: data.physicalIndication || data.description || '',
    };
}
